import React from 'react';
import './App.css';

export default function Home() {
    return (
        <div className="Home">
            {/*<h1>Home</h1>*/}
            <div className="Home-Photo">
                <img id="profilepic" src="https://tashinamgyal.s3.eu-west-2.amazonaws.com/tashi.jpeg" alt="Tashi" />
            </div>
            <div className="Home-Header">
                Interactive AI PhD Student at University of Bristol.
            </div>
            <div className="Home-Body">
                Hi, I'm Tashi 👋
                <br /><br />
                My undergraduate Tonmeister degree was at the interface between maths, physics and music. This degree taught me how important it is to think about engineering and its creative uses, which is a big part of Interactive AI. My undergraduate thesis was on ‘The Effect of Inharmonicity on the Perception of Warmth in Synthesised Piano Tones’. I became very interested in psychoacoustics and the neuroscience behind our perception of sound. This combined with wanting to do the most good with my career led me towards an interest in AI and its huge potential for social impact.
                <br /><br />
                After reading around in the area and taking many online courses to brush up on my coding skills I took my masters degree in Intelligent and Adaptive Systems, which combined more philosophical questions such as ‘what is life?’, ‘what is intelligence’ and ‘what is consciousness’ with technical skills in machine learning and natural language processing. My thesis was on ’Safe Exploration through Active Inference’ in which I simulated artificial agents learning to reach a goal in a safe way i.e. without taking any actions which might harm itself or things in its environment.
                <br /><br />
                I'm now working on generative models for music and how to make them more interactive and controllable. You can have a go with the models I'm developing on this website.
                <br /><br />
                In my spare time I like to do yoga 🧘 play the piano 🎹 and collect plants 🌱
            </div>
        </div>
    );
}
